import { render, staticRenderFns } from "./FamilyByIdView.vue?vue&type=template&id=111ccf9b&scoped=true"
import script from "./FamilyByIdView.vue?vue&type=script&lang=js"
export * from "./FamilyByIdView.vue?vue&type=script&lang=js"
import style0 from "./FamilyByIdView.vue?vue&type=style&index=0&id=111ccf9b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111ccf9b",
  null
  
)

export default component.exports